import React from 'react';
import AdminUsers from '../../components/AdminNext/AdminUsers';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

/*
 * Sengaja TIDAK memakai gerbang `isSuperAdmin` seperti layar klasik.
 *
 * Di sistem ini hanya satu akun yang punya kolom itu, dan akun itu milik
 * vendor — sehingga pemilik platform sendiri tidak pernah bisa membuka
 * halaman admin users. Melihat siapa saja yang punya akses tidak berbahaya;
 * yang berbahaya adalah mengubahnya, dan itu dijaga di sisi server
 * (createAdminUser dan deleteAdminUser), bukan di sini.
 */
function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Admin users — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <AdminUsers />
      </HeadLessLayout>
    )
  };
}

export default action;
